module.exports = __webpack_public_path__ + "img/vote.e09c3903.png";